/* eslint-disable react-hooks/exhaustive-deps */
import { Link } from "react-router-dom";
import React, { useEffect, useState } from "react";
import { useDoSeeDataContext } from "../../../context/doSeeData/DoSeeDataContext";
import { pushOneMinistry } from "../../../middlewares/sysNavigation/SysNavigation";
import { BreadCrumbComponent } from "../../../middlewares/breadCrumb/BreadCrumbComponent";
import {
  Modal,
  GoBack,
  MyButton,
  MySearch,
  Pagination,
  DashboardIntro,
} from "../../home/component/Component";
import { _TYPES_ } from "../utils/types";
import { _PAGE_SIZE_ } from "../../../middlewares/other/tools";
import { useGeoPositionContext } from "../utils/geoPosition";
import { useAdminContext } from "../../../context/admin/context/AdminContext";
import PromoteContent from "../utils/PromoteContent";
import { FaRegCheckSquare, FaRegSquare, FaRegTrashAlt } from "react-icons/fa";
import { RiRefreshLine } from "react-icons/ri";

const addRoute = "/data/ministry/add";
const editRoute = "/data/ministry/edit";
const doseeDataRoutes = "/dosee/data";

const Overview = () => {
  const [ministriesList, setMinistriesList] = useState([]);
  const { ministries, ministriesCount, fetchDoSeeData, deleteOneContent } =
    useDoSeeDataContext();
  const [page, setPage] = useState(1);
  const [pageSize, setPageSize] = useState(_PAGE_SIZE_);

  const [localSearch, setLocalSearch] = useState([]);

  const [loading, setLoading] = useState(false);
  const [selectedContentIds, setSelectedContentIds] = useState([]);

  const {
    country_id,
    entry_label,
    first_level_id,
    fourth_level_id,
    second_level_id,
    third_level_id,
  } = useGeoPositionContext();

  const data_request_body = {
    country_id,
    first_level_id,
    second_level_id,
    third_level_id,
    fourth_level_id,
    content: _TYPES_.MINISTRY,
  };

  useEffect(() => {
    if (!ministries) fetchDoSeeData(data_request_body, page, pageSize);
    setMinistriesList(ministries);
  }, [ministries]);

  const reloadData = () => fetchDoSeeData(data_request_body, page, pageSize);

  const SearchList = (e) => {
    const key = e.target.value.toString().toLowerCase();
    let searchArray = [];
    ministries.map((mstry) => {
      if (mstry?.title.toString().toLowerCase().includes(key))
        return searchArray.push(mstry);
      return true;
    });

    setMinistriesList(searchArray);
    if (key === "") setMinistriesList(ministries);
  };

  const LocalData = localSearch?.length > 0 ? localSearch : ministriesList;

  const deleteMany = async () => {
    setLoading(true);

    for (let i = 0; i < selectedContentIds.length; i++) {
      await deleteOneContent({
        data_id: selectedContentIds[i],
        content: _TYPES_.MINISTRY,
      });
    }

    setLoading(false);

    reloadData();
  };

  return (
    <div className="p-3 lg:p-4  h-full overflow-y-auto rounded-b-xl bg-gray-50">
      <BreadCrumbComponent />
      <GoBack props={{ route: doseeDataRoutes }} />
      <div className="my-3">
        <DashboardIntro props={{ intro: `Ministries`, name: entry_label }} />
      </div>

      <div className="flex flex-col justify-center">
        <MySearch
          type={_TYPES_.MINISTRY}
          value={localSearch}
          showGlobalSearch={true}
          setValue={setLocalSearch}
          onChange={(e) => SearchList(e)}
        />

        <div className="w-full flex justify-end my-5">
          {country_id ? (
            <Link to={addRoute}>
              <MyButton
                title="Add Ministry"
                className="py-3 px-8 bg-blue-900 hover:bg-blue-600"
                onClick={() => {}}
              />
            </Link>
          ) : null}
        </div>

        <div className="flex items-center">
          <MyButton className="text-black flex items-center space-x-2">
            {selectedContentIds?.length === LocalData?.length ? (
              <FaRegCheckSquare
                onClick={() => setSelectedContentIds([])}
                className="text-green-500 cursor-pointer text-lg"
              />
            ) : (
              <FaRegSquare
                onClick={() => {
                  const ids = LocalData.map(
                    (ministry) => ministry?.ministry_id
                  );
                  setSelectedContentIds(ids);
                }}
                className="cursor-pointer text-black text-lg"
              />
            )}
            <p className="text-black">
              {selectedContentIds.length === LocalData?.length
                ? "Unselect All"
                : "Select All"}
            </p>
          </MyButton>

          <MyButton
            onClick={deleteMany}
            className="text-black flex items-center space-x-2"
          >
            {loading ? (
              <RiRefreshLine className="text-black text-lg animate-spin" />
            ) : (
              <FaRegTrashAlt className="text-red-500 cursor-pointer text-base" />
            )}
            <p className="text-black">
              Delete {selectedContentIds?.length} Item(s)
            </p>
          </MyButton>
        </div>

        <div className="mb-5 overflow-y-auto w-full py-2">
          <table className="table-auto w-full border-collapse border border-gray-300 text-xs text-left">
            <thead>
              <tr className="space-x-2">
                <th className="border p-2 lg:px-4 font-bold w-1/3">Select</th>
                <th className="border p-2 lg:px-4 font-bold w-1/3">Title</th>
                <th className="border p-2 lg:px-4 font-bold w-1/3">Slug</th>
                <th className="border text-center w-1/3">Action</th>
              </tr>
            </thead>
            <tbody className="space-x-2 text-left border-gray-300">
              {ministries || LocalData ? (
                LocalData?.map((mstry, index) => (
                  <tr key={index}>
                    <td className="border px-2 lg:px-4 w-1/3 text-lg">
                      {selectedContentIds.includes(mstry?.ministry_id) ? (
                        <MyButton
                          onClick={() => {
                            const filteredIds = selectedContentIds.filter(
                              (id) => id !== mstry?.ministry_id
                            );
                            setSelectedContentIds(filteredIds);
                          }}
                        >
                          <FaRegCheckSquare className="text-green-500 cursor-pointer text-lg" />
                        </MyButton>
                      ) : (
                        <MyButton
                          onClick={() =>
                            setSelectedContentIds([
                              ...selectedContentIds,
                              mstry?.ministry_id,
                            ])
                          }
                        >
                          <FaRegSquare className="cursor-pointer text-black text-lg" />
                        </MyButton>
                      )}
                    </td>
                    <td className="border px-2 lg:px-4 w-1/3">
                      {mstry?.title}
                    </td>
                    <td className="border px-2 lg:px-4 w-1/3">{mstry?.slug}</td>
                    <td className="border w-1/3">
                      <ActionButton props={mstry} reloadData={reloadData} />
                    </td>
                  </tr>
                ))
              ) : (
                <tr>
                  <td className="border px-2 lg:px-4 w-1/3">...</td>
                  <td className="border px-2 lg:px-4 w-1/3">...</td>
                  <td className="border px-2 lg:px-4 w-1/3">...</td>
                  <td className="border px-2 lg:px-4 w-1/3">...</td>
                </tr>
              )}
            </tbody>
          </table>
        </div>

        <Pagination
          page={page}
          setPage={setPage}
          pageSize={pageSize}
          setPageSize={setPageSize}
          total_items={ministriesCount}
          callbackFunction={(p, size) => {
            fetchDoSeeData(data_request_body, p, size);
          }}
        />
      </div>
    </div>
  );
};

/**
 * @author Ntavigwa Bashombe
 * @param {*} props
 * @returns
 */
const ActionButton = ({ props, reloadData }) => {
  const { sysAdmin } = useAdminContext();
  const isSuperAdmin = ["super_admin", "admin"].includes(sysAdmin?.role);
  const { ministries, deleteOneContent, updateOneContent } =
    useDoSeeDataContext();

  const [showModal, setShowModal] = useState(false);

  const [promote, setPromote] = useState(false);
  const [promoteLoader, setPromoteLoader] = useState(false);

  const ministry_id = props.ministry_id;
  const ministry_title = props.title;
  const ministry = props;

  const deleteOneMinistryById = async (ministry_id) => {
    const { status } = await deleteOneContent({
      data_id: ministry_id,
      content: _TYPES_.MINISTRY,
    });

    setShowModal(false);

    if (status === 200) {
      reloadData();
    }
  };

  const buildData = (object, position) => {
    return {
      promoted: `${position}`,
      country_id: object?.country_id,
      description: object?.description,
      first_level_id: object?.first_level_id,
      fourth_level_id: object?.fourth_level_id,
      second_level_id: object?.second_level_id,
      slug: object?.slug,
      status: object?.status,
      third_level_id: object?.third_level_id,
      thumbnail: object?.thumbnail,
      title: object?.title,
    };
  };

  /**
   *
   * @author Ntavigwa Bashombe
   * @param {*} ministry
   */
  const promotion = async (position) => {
    const previousPromoted = ministries?.find(
      (ministry) => ministry?.promoted === String(position)
    );

    setPromoteLoader(true);

    const { status } = await updateOneContent({
      data_id: ministry?.ministry_id,
      data: buildData(props, position),
      content: _TYPES_.MINISTRY,
    });

    if (previousPromoted) {
      await updateOneContent({
        data_id: previousPromoted?.ministry_id,
        data: buildData(previousPromoted, "no"),
        content: _TYPES_.MINISTRY,
      });
    }

    if (status === 200) {
      reloadData();
    }
  };

  const suspension = async (ministry) => {
    const data = {
      country_id: ministry?.country_id,
      description: ministry?.description,
      first_level_id: ministry?.first_level_id,
      fourth_level_id: ministry?.fourth_level_id,
      second_level_id: ministry?.second_level_id,
      slug: ministry?.slug,
      status: ministry?.status === 1 ? 0 : 1,
      third_level_id: ministry?.third_level_id,
      thumbnail: ministry?.thumbnail,
      title: ministry?.title,
    };

    const { status } = await updateOneContent({
      data_id: ministry?.ministry_id,
      data: data,
      content: _TYPES_.MINISTRY,
    });

    if (status === 200) {
      reloadData();
    }
  };

  return (
    <>
      <Modal
        props={{
          name: ministry_title,
          showModal: showModal,
          setShowModal: () => setShowModal(false),
          delete: () => deleteOneMinistryById(ministry_id),
        }}
      />

      <PromoteContent
        visible={promote}
        setVisible={setPromote}
        loading={promoteLoader}
        ids={ministries
          ?.filter(
            (ministry) =>
              !["yes", "no", null, undefined].includes(ministry?.promoted)
          )
          .map((ministry) => ({
            id: ministry?.ministry_id,
            title: ministry?.title,
            position: parseInt(ministry?.promoted),
          }))}
        onClick={(position) => promotion(position)}
      />

      <div className="flex flex-row justify-end items-center px-2 py-3 space-x-4 text-xs">
        {isSuperAdmin ? (
          <>
            <MyButton
              title={ministry?.status === 1 ? "Suspend" : "Unsuspend"}
              className={`py-3 px-8 ${
                ministry?.status === 1
                  ? "bg-gray-900 hover:bg-gray-600"
                  : "bg-orange-900 hover:bg-orange-600"
              }`}
              onClick={() => suspension(ministry)}
            />
            <MyButton
              title={
                ["yes", "no", null, undefined].includes(ministry?.promoted)
                  ? "Promote"
                  : "Unpromote"
              }
              className={`py-3 px-8 ${
                ["yes", "no", null, undefined].includes(ministry?.promoted)
                  ? "bg-gray-900 hover:bg-gray-600"
                  : "bg-orange-900 hover:bg-orange-600"
              }`}
              onClick={() => setPromote(true)}
            />
          </>
        ) : null}

        <Link to={editRoute}>
          <MyButton
            title="Edit"
            className={`py-3 px-8 bg-blue-800 hover:bg-blue-600`}
            onClick={() => pushOneMinistry(ministry)}
          />
        </Link>
        <MyButton
          title="Delete"
          className={`py-3 px-8 bg-red-800 hover:bg-red-600`}
          onClick={() => setShowModal(true)}
        />
      </div>
    </>
  );
};

export default Overview;
